import z from "zod";
import { SportKeySchema } from "./plain-schemas";
import { STAT_TYPE_INFO, STAT_TYPES } from "./stat-types";

export function selectStatTypes(sport_key: z.infer<typeof SportKeySchema>) {
	const st = STAT_TYPES.filter(n => n.startsWith(sport_key));
	return st.map(n => {
		const info = STAT_TYPE_INFO[n];
		if(info === undefined) {
			throw new Error(`selectStatTypes: missing info for stat type "${n}"`);
		}
		return {
			id: n,
			short_title: info.short_title,
			full_title_template: info.full_title_template,
		}
	})
}
